import { Alert, Button, Grid, Snackbar, Tooltip, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import StlapFooter from "../CustomComponents/StlapFooter";
import { RepaymentStructureFilterReducerAction } from "../Store/RepaymentStructureFilter/RepaymentStructureFilterReducer";
import RepaymentStructure from "../Disbursement/Disbursement_Detail/Disbursement_Common/RepaymentStructure";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const RepaymentStructureFilter = () => {
  //Creating Dispatch
  const dispatch = useDispatch();
  //Selecting from store
  const filterValues = useSelector(
    (state) => state.repaymentStructureFilter.filterValues
  );
  //Getting value from the store
  const touchHandler = useSelector(
    (data) => data.repaymentStructureFilter.touchHandler
  );
  const valueIsValid = useSelector(
    (data) => data.repaymentStructureFilter.valueIsValid
  );
  //shortcut
  const downloadRef = useRef(null);
  const clearRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keyup", onKeyPressEventHandler);
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    dispatch(
      CommonShortCutAction.removeDefaultShortCutValue({
        event: event,
        screen: "repaymentStructure",
      })
    );
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      if (charCode === "j") {
        downloadRef.current.click();
      } else if (charCode === "d") {
        clearRef.current.click();
      }
    }
  };

  //Error Status checking
  const branchHasError =
    touchHandler.branchTouched && !valueIsValid.branchIsValid;
  const applicationHasError =
    touchHandler.applicationTouched && !valueIsValid.applicationIsValid;
  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const [showRepaymentStructure, setShowRepaymentStructure] = useState(false);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  useEffect(() => {
    onClearBtnClickHandler();
    dispatch(RepaymentStructureFilterReducerAction.resetFilterValues());
    const branchArr = GetBranchDetails();
    dispatch(
      RepaymentStructureFilterReducerAction.updateBranchArray(branchArr)
    );
  }, []);

  const onClearBtnClickHandler = () => {
    dispatch(RepaymentStructureFilterReducerAction.updateBrachIsTouched(false));
    dispatch(
      RepaymentStructureFilterReducerAction.updateApplicationNumberIsTouched(
        false
      )
    );
    dispatch(RepaymentStructureFilterReducerAction.updateBranchValue(null));
    dispatch(
      RepaymentStructureFilterReducerAction.updateApplicationValue(null)
    );
    dispatch(RepaymentStructureFilterReducerAction.updateApplicationArray([]));
    setShowRepaymentStructure(false);
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const branchOnChangeHandler = async (value) => {
    setShowRepaymentStructure(false);
    dispatch(RepaymentStructureFilterReducerAction.updateBranchValue(value));
    if (value && value !== "") {
      dispatch(
        RepaymentStructureFilterReducerAction.updateApplicationValue(null)
      );
      try {
        const branchCodeValue = getSelectedBranchCode(value.label);
        const response = await axios.post("/losCustomer/getLosAppNumByStatus", {
          branch: value.label,
          status: ["Disbursement Completed", "Disbursed", "Requested"],
          branchCode: branchCodeValue,
        });
        dispatch(
          RepaymentStructureFilterReducerAction.updateApplicationArray(
            response.data.sort()
          )
        );
      } catch (error) {
        throw Error(error);
      }
    } else {
      dispatch(
        RepaymentStructureFilterReducerAction.updateApplicationArray([])
      );
      dispatch(
        RepaymentStructureFilterReducerAction.updateApplicationValue(null)
      );
    }
  };
  const downloadRepaymentStructureHandler = async () => {
    dispatch(RepaymentStructureFilterReducerAction.updateBrachIsTouched(true));
    dispatch(
      RepaymentStructureFilterReducerAction.updateApplicationNumberIsTouched(
        true
      )
    );
    if (valueIsValid.branchIsValid && valueIsValid.applicationIsValid) {
      setShowRepaymentStructure(true);
    }
  };
  return (
    <>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord"
          title="Repayment Structure"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Branch"
                label="Branch"
                required={true}
                autoCompleteValues={filterValues.branchArray}
                value={filterValues.branchValue}
                onChange={(e, value) => {
                  branchOnChangeHandler(value);
                }}
                onBlur={() => {
                  dispatch(
                    RepaymentStructureFilterReducerAction.updateBrachIsTouched(
                      true
                    )
                  );
                }}
              />
              {branchHasError && <p className="error">Please Select Branch</p>}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Application Number"
                label="Application Number"
                required={true}
                autoCompleteValues={filterValues.applicationArray}
                value={filterValues.applicationValue}
                onChange={(event, value) => {
                  dispatch(
                    RepaymentStructureFilterReducerAction.updateApplicationValue(
                      value
                    )
                  );
                  setShowRepaymentStructure(false);
                }}
                onBlur={() => {
                  dispatch(
                    RepaymentStructureFilterReducerAction.updateApplicationNumberIsTouched(
                      true
                    )
                  );
                }}
              />
              {applicationHasError && (
                <p className="error">Please Select Application Number</p>
              )}
            </Grid>
          </Grid>
          <Box
            sx={{
              marginTop: "12px",
              marginBottom: "8px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Tooltip title="Ctrl+J" placement="top">
              <Button
                variant="contained"
                type="submit"
                sx={{ height: "2rem" }}
                onClick={downloadRepaymentStructureHandler}
                ref={downloadRef}
              >
                Repayment Structure
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+D" placement="top">
              <Button
                sx={{
                  marginLeft: "1rem",
                  color: "white",
                  backgroundColor: "black",
                  height: "2rem",
                }}
                onMouseOver={({ target }) => {
                  target.style.backgroundColor = "black";
                  target.style.color = "white";
                }}
                variant="contained"
                onClick={() => {
                  onClearBtnClickHandler();
                }}
                ref={clearRef}
              >
                Clear
              </Button>
            </Tooltip>
          </Box>
        </AccordianContainer>
        {showRepaymentStructure && <RepaymentStructure />}
      </Box>
      <StlapFooter />
    </>
  );
};
export default RepaymentStructureFilter;
